//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        defaultTab: {
            type: Number,
            default: null,
        },
        tabclass: {
            type: String,
            default: null,
        },
        prerenderAll: {
            type: Boolean,
            default: true,
        },
        renderAll: {
            type: Boolean,
            default: true,
        },
        plain: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
        hashchange: {
            type: Boolean,
            default: false,
        },
        fullwidth: {
            type: Boolean,
            default: false,
        },
        allowOverflow: {
            type: Boolean,
            default: false,
        },
        bold: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentTab: -1,
            /** @type {Array<import('@tidal/styles-tabs').TabComponentVNode | import('@tidal/styles-tabs').TabComponent>} */
            tabs: [],
            previousTab: -1,
        };
    },
    computed: {
        /** @return {string} */
        classname() {
            if (!this.plain) {
                if (this.tabs.length > 6) {
                    console.warn('<tidal-tabs> does not support more than six tabs. Continue at your own risk!');
                }
                return 'tidal-tabs--tab-' + this.tabs.length;
            }
            return '';
        },
        /** @return {number} */
        defaultTabIndex() {
            if (!this.defaultTab) {
                return 0;
            }

            const tab = this.defaultTab - 1;
            if (tab > -1 && tab < this.tabs.length) {
                return tab;
            }

            return 0;
        },
    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.selectTabFromCurrentHash);
    },
    created() {
        if (this.$slots.default) {
            for (const i in this.$slots.default) {
                const tabComponentVNode = /** @type {import('@tidal/styles-tabs').TabComponentVNode} */(this.$slots.default[i]);
                if (tabComponentVNode.tag) {
                    // @ts-ignore
                    tabComponentVNode.name = tabComponentVNode.componentOptions.propsData.name;
                    this.tabs.push(tabComponentVNode);
                }
            }

            if (this.tabs.length) {
                const defaultTab = this.tabs[this.defaultTabIndex];
                defaultTab.isActive = true;
            }
        }
    },
    mounted() {
        // Force Vue to refresh tab array (fixes bug in v.2.5.14)
        this.tabs.splice(0, 0);

        if (this.hashchange) {
            window.addEventListener('hashchange', this.selectTabFromCurrentHash);
        }

        if (window.location.hash.length && this.findTab(window.location.hash)) {
            this.selectTab(window.location.hash);
            return;
        }

        if (this.tabs.length) {
            this.selectTab(this.tabs[this.defaultTabIndex].hash);
        }
    },
    methods: {
        /** @param {import('@tidal/styles-tabs').TabComponent} item */
        addTab(item) {
            const index = this.tabs.indexOf(/** @type {import('@tidal/styles-tabs').TabComponentVNode} */(item.$vnode));
            item.isActive = index === this.defaultTabIndex;
            this.tabs[index] = item;
        },
        /**
         * @param {string} hash
         * @return {import('@tidal/styles-tabs').TabComponent | import('@tidal/styles-tabs').TabComponentVNode | null}
         */
        findTab(hash) {
            const len = this.tabs.length;
            if (len) {
                let i = 0;
                while (i < len) {
                    const tab = this.tabs[i];
                    if (tab.hash === hash) {
                        this.currentTab = i;
                        return tab;
                    }
                    i++;
                }
            }
            return null;
        },
        /**
         * @param {string} selectedTabHash
         * @param {boolean} [fromListener]
         * @return {false | undefined}
         */
        selectTab(selectedTabHash, fromListener) {
            const selectedTab = this.findTab(selectedTabHash);
            if (!selectedTab) {
                if (fromListener && selectedTabHash === '') {
                    return this.selectTab(this.tabs[0].hash);
                }
                return false;
            }

            if (this.previousTab !== this.currentTab) {
                this.tabs.forEach(tab => {
                    const isActive = tab.hash === selectedTab.hash;
                    tab.isActive = isActive;
                    if (!isActive) {
                        tab.isNext = false;
                        tab.isPrev = false;
                    } else if (this.previousTab !== -1) {
                        tab.isNext = this.previousTab < this.currentTab;
                        tab.isPrev = this.previousTab > this.currentTab;
                    }
                });

                if (this.hashchange && this.previousTab !== -1) {
                    history.replaceState({}, '', location.pathname + location.search + selectedTabHash);
                }

                this.previousTab = this.currentTab;
            }
        },
        selectTabFromCurrentHash() {
            this.selectTab(window.location.hash, true);
        },
    },
};
